import { render, staticRenderFns } from "./NotificationsBadge.vue?vue&type=template&id=4ffb5ad8&scoped=true&"
import script from "./NotificationsBadge.vue?vue&type=script&lang=js&"
export * from "./NotificationsBadge.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsBadge.vue?vue&type=style&index=0&id=4ffb5ad8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffb5ad8",
  null
  
)

export default component.exports